import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import Info from "./common/info";
import CompanyForm from "./company/companyForm";
import BadgesModal from "./company/modal/badgesModal";

import { SettingContent } from "../styled/setting";
import { defaultCompany } from "../function/store";

import useUploadFiles from "../../../../../hooks/useUploadFiles";
import uuid from "react-uuid";

const Company = ({
  info,
  clickImages,
  setActive,
  openModal,
  closeModal,
  badges,
  currentAuth,
  company,
  selectCompany,
  getCompany,
}) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state?.user?.data[0]);

  const { uploadFiles, dataURItoBlob, readFileAsDataURL } = useUploadFiles();

  const [formData, setFormData] = useState(defaultCompany);
  const [modal, setModal] = useState("");
  const [files, setFiles] = useState([]);

  useEffect(() => {
    console.log(company);

    setFormData((data) => ({
      ...data,
      cmpnyImage: company?.cmpnyImage
        ? company.cmpnyImage.map((image) => ({ id: uuid(), path: image }))
        : [],
      cmpnyNm: company?.cmpnyNm || "",
      cmpnySe: company?.cmpnySe || "",
      cmpnyBadge: company?.cmpnyBadge || [],
      cmpnyBadgeText: company?.cmpnyBadgeText || [],
      addr: company?.addr || "",
      addrDetail: company?.addrDetail || "",
      item: company?.item || "",
      tel: company?.tel || "",
      hashTag: company?.hashTag || [],
      tag: "",
      notice: company?.notice || "",
      originInfo: company?.originInfo || "",
    }));
  }, [company]);

  const closeForm = () => {
    setActive("menuBoard");
    setFormData(defaultCompany);
  };

  // 유효성 체크
  const validationCheck = () => {
    const fieldLabels = {
      cmpnyNm: "회사명",
      cmpnySe: "업종",
      tel: "연락처",
      addr: "주소",
    };

    for (let key in fieldLabels) {
      if (textNotExist(formData[key])) {
        const label = fieldLabels[key] || "";
        toast.error(`${chooseParticle(label, "을를")} 입력해주세요.`);
        return;
      }
    }

    return true;
  };

  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: "회사 정보 수정",
      message: ["변경하신 회사 정보를 수정하시겠습니까?"],
      handleConfirm: handleSubmit,
    });
  };

  // 서버 저장
  const handleSubmit = async () => {
    try {
      const url = "/erp/ss/company/upsert";

      let coords = { longitude: company.longitude, latitude: company.latitude };
      if (company.addr !== formData.addr) {
        coords = await searchAddress();
      }

      let uploadedImages = [];
      if (formData.cmpnyImage.length > 0) {
        const serverData = await uploadImages();
        uploadedImages = replaceImages(formData.cmpnyImage, serverData);
      }

      const body = {
        input: {
          longitude: coords.longitude,
          latitude: coords.latitude,
          addrDetail: formData.addrDetail,
          addr: formData.addr,
          tel: formData.tel,
          hashTag: formData.hashTag,
          item: formData.item,
          cmpnyBadge: formData.cmpnyBadge,
          cmpnyImage: uploadedImages,
          cmpnySe: formData.cmpnySe,
          cmpnyNm: formData.cmpnyNm,
          cmpnyNo: selectCompany.value,
        },
      };

      await axios.post(url, body);
      toast.success("회사 정보가 성공적으로 수정되었습니다.");
      setActive("menuBoard");
      getCompany(selectCompany);
    } catch (error) {
      console.error(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  const searchAddress = async () => {
    const url = "/api/getCoordinates";
    const body = { address: formData.addr };

    try {
      const res = await axios.post(url, body);
      const data = res?.data?.documents;
      if (res.status === 200 && data && data.length > 0) {
        return { latitude: data[0].y, longitude: data[0].x };
      }
    } catch (error) {
      console.error(error);
      return { latitude: null, longitude: null };
    }
  };

  // 이미지 추가
  const addImages = async (e) => {
    const inputFiles = e.target.files;
    if (!inputFiles?.length) return;

    const files = Array.from(inputFiles);

    const totalCount = formData.cmpnyImage.length + files.length;
    if (totalCount > 5) {
      toast.error("이미지는 최대 5장까지 첨부 가능합니다.");
      return;
    }

    const results = await Promise.all(
      files.map(async (file) => {
        const id = uuid();
        const path = await readFileAsDataURL(file);
        return {
          image: { path, id },
          file: { file, id },
        };
      }),
    );

    setFormData((prev) => ({
      ...prev,
      cmpnyImage: [...prev.cmpnyImage, ...results.map((r) => r.image)],
    }));

    setFiles((prev) => [...prev, ...results.map((r) => r.file)]);
  };

  // 이미지 업로드
  const uploadImages = async () => {
    try {
      const base64Items = formData.cmpnyImage.filter((item) => item.path.startsWith("data:image/"));

      const filesToUpload = base64Items.map((item) => {
        const blob = dataURItoBlob(item.path);
        const ext = blob.type.split("/")[1];
        return new File([blob], `${item.id}.${ext}`, { type: blob.type });
      });

      const uploaded = await uploadFiles(filesToUpload);

      return uploaded.map((item, idx) => ({
        id: base64Items[idx].id,
        fileName: item.fileName,
      }));
    } catch (err) {
      console.error("이미지 업로드 실패", err);
      return [];
    }
  };

  // 업로드된 이미지로 대체
  const replaceImages = (imgUrlList, uploadedList) => {
    return imgUrlList.map((item) => {
      const matched = uploadedList.find((u) => u.id === item.id);
      return matched ? matched.fileName : item.path;
    });
  };

  // 이미지 삭제
  const deleteImages = (item) => {
    openModal({
      isOpen: true,
      type: "confirmation",
      title: "이미지 삭제",
      message: [`이미지를 삭제하시겠습니까?`],
      handleConfirm: () => {
        setFormData((data) => ({
          ...data,
          cmpnyImage: [...data.cmpnyImage].filter((ele) => ele.id !== item.id),
        }));
        setFiles(files.filter((img) => img.id !== item.id));
        closeModal();
      },
      handleCancel: () => closeModal(),
    });
  };

  const renderModal = () => {
    switch (modal) {
      case "badge":
        return (
          <BadgesModal
            badges={badges}
            formData={formData}
            setFormData={setFormData}
            setModal={setModal}
          />
        );
    }
  };

  return (
    <SettingContent>
      {modal && renderModal()}
      <Info
        message="회사 정보 수정"
        actions={[
          { label: "취소", func: closeForm, key: "cancel" },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <CompanyForm
        formData={formData}
        setFormData={setFormData}
        setModal={setModal}
        currentAuth={currentAuth}
        badges={badges}
        addImages={addImages}
        deleteImages={deleteImages}
      />
    </SettingContent>
  );
};

export default Company;
